import React from 'react';
import { TextProps } from 'react-native';
import styled from 'styled-components/native';

import Colors from '../constants/Colors';
import { B, P } from './Typography';

const StyledBoldText = styled(B)<LinkProps>`
  color: ${p =>
    p.disabled ? Colors.buttonDisabled : p.inverse ? '#000' : Colors.link};
  text-decoration-line: underline;
` as React.FC<LinkProps>;

const StyledRegularText = styled(P)<LinkProps>`
  color: ${p =>
    p.disabled ? Colors.buttonDisabled : p.inverse ? '#000' : Colors.link};
  text-decoration-line: underline;
` as React.FC<LinkProps>;

export type LinkProps = TextProps & {
  disabled?: boolean;
  inverse?: boolean;
  regular?: boolean;
};

/**
 * The Link component renders a Text component with the theme color and
 * inherits the font styling from the parent component. Make sure you wrap the
 * Link component inside a styled Text component.
 */
const Link: React.FC<LinkProps> = ({
  inverse,
  regular,
  children,
  ...props
}) => {
  let StyledTextCmp = StyledBoldText;
  if (regular) {
    StyledTextCmp = StyledRegularText;
  }
  return (
    <StyledTextCmp inverse={inverse} {...props}>
      {children}
    </StyledTextCmp>
  );
};

export default Link;
